import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import DayTab from "../../../components/Interventions/DayTab";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { setFilteredAndSortedInterventions } from "../../../redux/intervention/interventionActions";
import { arraysAreSame } from "../../../lib/array_helper";

class ListMode extends Component {
    shouldComponentUpdate(nextProps) {
        let filteredAndSortedInterventionsChanged = !arraysAreSame(
            this.props.interventionsFilters.filteredAndSortedInterventions,
            nextProps.interventionsFilters.filteredAndSortedInterventions,
            true
        );

        return filteredAndSortedInterventionsChanged;
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div>
                <DayTab
                    globalContainer={this.props.globalContainer}
                    selectedDay={this.props.interventionsFilters.selectedDay}
                    interventionsFilters={this.props.interventionsFilters}
                    filteredAndSortedInterventions={this.props.interventionsFilters.filteredAndSortedInterventions}
                    setFilteredAndSortedInterventions={this.props.setFilteredAndSortedInterventions}
                />
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedInterventions: (interventionsFilters) =>
            dispatch(setFilteredAndSortedInterventions(interventionsFilters)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ListMode);
